import React, { useState } from "react";
import { errorHandler } from "../../shared/Utils/ErrorHandler";
import SecondaryButton from "../../shared/Buttons/SecondaryButton";
import { addUpdate } from "../../../api/AddUpdate";

const CampaignUpdateForm = ({ campaignId, campaignData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateData, setUpdateData] = useState({
    update_content: "",
    campaign: campaignId,
    campaign_type: campaignData.campaign_type,
  });
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  /* Handles input change */
  const handleUpdateChange = (e) => {
    const { name, value } = e.target;
    setUpdateData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Make form and API call
  const submitUpdate = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    setErrorMsg("");
    setSuccessMsg("");
    try {
      let formData = new FormData();
      Object.keys(updateData).forEach((key) => {
        if (updateData[key] !== "") {
          formData.append(key, updateData[key]);
        }
      });
      const response = await addUpdate(formData);
      setSuccessMsg("Successfully posted an update!");

      // Reset form
      setUpdateData({
        update_content: "",
        campaign: campaignId,
        campaign_type: campaignData.campaign_type,
      });

    } catch (error) {
      const errorMsg = errorHandler(error);
      console.error("Error submitting the update:", error);
      setErrorMsg(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={submitUpdate} className="w-full mb-6">
      <h2 className="!font-bold !text-[16px] text-gray-900 text-left mb-3">
        Post an Update <span className="text-red-500">*</span>
      </h2>
      <textarea
        name="update_content"
        value={updateData.update_content}
        onChange={handleUpdateChange}
        placeholder="Add your text here..."
        className="p-4 border border-gray-300 text-gray-700 !min-h-28 rounded-lg w-full mb-4 focus:outline-none focus:border-blue"
      />
      <SecondaryButton disabled={isSubmitting} className="px-8">
        {isSubmitting ? "Posting..." : "Post Update"}
      </SecondaryButton>
      {errorMsg && <p className="text-red-500 mt-2 text-sm">{errorMsg}</p>}
      {successMsg && <p className="text-green-500 mt-2 text-sm">{successMsg}</p>}
    </form>
  );
};

export default CampaignUpdateForm;
